

































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { JobModel, Selectable } from '@/model/job';
import { skillList7th } from '../../../module/skillList';
interface Skill {
  label: string;
  initial: number;
  keywords: string[];
}

interface Confidence {
  label: string;
  initial: number;
  interestpoint: number;
  jobpoint: number;
}

interface Payload {
  label: string;
  skills: Skill[];
  confidence: Confidence;
  jobPointFormula: number;
}

@Component
export default class Presentational extends Vue {
  public currentJob: JobModel = {} as JobModel;
  public currentSelectable: Selectable = {} as Selectable;
  public activatedSkills: Skill[] = [];
  public selectedSkills: Skill[] = [];
  public page: number = 0;
  public isError: boolean = false;
  public jobPointFormula: number = 0;
  public confidence: Confidence = {
    label: '信用',
    initial: 0,
    interestpoint: 0,
    jobpoint: 0,
  };

  @Prop() public jobList;

  @Emit() public close() {}
  @Emit() public entry(payload: Payload) {}

  private get jobs() {
    return this.jobList;
  }

  public get skills() {
    const searched: Skill[] = [];
    this.currentSelectable.skills.forEach(item => {
      searched.push(this.skillSearch(item)[0]);
    });
    return searched.length > 0 ? searched : skillList7th;
  }

  public get maxPage() {
    return this.currentJob.skill.selectables.length + 1;
  }

  public formulaString(payload: number): string {
    switch (payload) {
      case 0:
        return 'EDU × 4';
        break;
      case 1:
        return 'EDU × 2 + DEX × 2';
        break;
      case 2:
        return 'EDU × 2 + STR × 2';
        break;
      case 3:
        return 'EDU × 2 + POW × 2';
        break;
      case 4:
        return 'EDU × 2 + APP × 2';
        break;
      default:
        return 'EDU × 4';
        break;
    }
  }

  public selectJob(payload: JobModel) {
    this.currentJob = payload;
    this.confidence.initial = payload.confidence.min;
    this.jobPointFormula = payload.pointFormula[0];
    this.page = 1;
    this.currentSelectable = this.currentJob.skill.selectables[this.page - 1];
    this.currentJob.skill.required.forEach(item => {
      this.selectedSkills.push(this.skillSearch(item)[0]);
    });
  }

  public skillSearch(label: string) {
    return skillList7th.filter(skill => {
      return skill.keywords.some(keyword => {
        return keyword.startsWith(label);
      });
    });
  }

  public activateSkill(skill: Skill) {
    this.activatedSkills.push(skill);
    if (this.activatedSkills.length > this.currentSelectable.count) {
      this.activatedSkills.shift();
    }
  }

  public selectJobPointFormula(type: number) {
    this.jobPointFormula = type;
  }

  public toBack() {
    this.page--;
    this.activatedSkills = [];
    if (this.page >= 1) {
      this.currentSelectable = this.currentJob.skill.selectables[this.page - 1];
      this.selectedSkills.splice(
        this.selectedSkills.length - this.currentSelectable.count,
        this.currentSelectable.count
      );
    } else {
      this.currentSelectable = {} as Selectable;
      this.selectedSkills = [];
    }
  }

  public toNext() {
    if (this.activatedSkills.length !== this.currentSelectable.count) {
      this.isError = true;
    } else {
      this.isError = false;
      this.page++;
      this.currentSelectable = this.currentJob.skill.selectables[this.page - 1];
      this.selectedSkills = [...this.selectedSkills, ...this.activatedSkills];
      this.activatedSkills = [];
    }
  }

  public onEntry() {
    const confidenceTotal = this.confidence.initial + this.confidence.interestpoint + this.confidence.jobpoint;
    if (this.currentJob.confidence.min <= confidenceTotal && confidenceTotal <= this.currentJob.confidence.max) {
      const payload = {
        label: this.currentJob.label,
        skills: this.selectedSkills,
        confidence: this.confidence,
        jobPointFormula: this.jobPointFormula,
      };
      this.isError = false;
      this.close();
      this.entry(payload);
    } else {
      this.isError = true;
    }
  }
}
